import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import GlassPanel from './common/GlassPanel';
import Button from './common/Button';
import { FORECAST_URL, BOOK_CALL_URL } from '../config/links';

const CTA = () => {
  return (
    <section className="relative pt-24 md:pt-32 pb-20 md:pb-24 bg-esf-black overflow-hidden">
      <div className="absolute inset-0 bg-radial-glow opacity-40" aria-hidden="true" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div variants={fadeInUp}>
            <GlassPanel className="p-10 md:p-14 text-center" hover={false}>
              <h2 className="text-display-lg text-esf-white text-balance">
                Ready to see what your fan base is worth?
              </h2>
              <p className="mt-5 text-body-lg text-esf-gray-300 text-pretty">
                Talk to us about what a platform for your club would look like — or
                run the numbers yourself first.
              </p>

              {/*
                Inverted relative to the hero. A visitor who has read this far
                has the intent for a conversation, so the call takes the primary
                slot and the self-serve tool becomes the lighter alternative.
              */}
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
                <Button href={BOOK_CALL_URL} variant="primary" size="lg" className="w-full sm:w-auto">
                  Book a call
                  <ArrowRight size={18} aria-hidden="true" />
                </Button>
                <Button href={FORECAST_URL} variant="secondary" size="lg" className="w-full sm:w-auto">
                  Estimate your revenue
                </Button>
              </div>
            </GlassPanel>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
